let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jcO8P")).then(() => parcelRequire('ks0bx'));